// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { chain as addToWishList } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { xIsAuthenticated } from "@pacific/App/Store/Selectors/GeneralSelectors";
import { formatCategories } from "@pacific/XDL/Utilities";
import { getDataLayer } from "@pacific/XDL/Utilities/dataLayer";

export const _GaAddToWishList = (props: any) => {
    const state = props.getState();
    const pageType = getCurrentPage(state).type
    const isPLP = pageType === "ProductListPage";
    const isPDP = pageType === "ProductDetailsPage";
    const isSearchPage = state.pages.productList.isSearchPage;

    const list = isSearchPage
        ? "Search Result Page"
        : isPLP
        ? "Product List Page"
        : isPDP
        ? "Product Detail Page"
        : null;

    const session = getSession(state);
    const currentBillTo = getCurrentBillToState(state).value;
    const dataLayer = getDataLayer();
    const isAuthenticated = xIsAuthenticated(state);
    if (!dataLayer || props.result?.errorMessage || !props.parameter.onSuccess) {
        return;
    }

    const lines = props.parameter.productInfos.map((productInfo: ProductInfo) => {
        const productState = getProductState(state, productInfo.productId)?.value;
        return {
            productId: productInfo.productId,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            pricing: productInfo.pricing,
            productErpNumber: (productInfo as any).productErpNumber || productState?.productNumber,
            productName: (productInfo as any).productName || productState?.productTitle,
            brand: productState?.brand,
            category: productState?.properties?.category,
        };
    });

    const googleAnalyticsData = {
        event: "add_to_wishlist",
        currency: session.currency?.currencyCode,
        value: lines.reduce((acc: number, line: any) => acc + line.pricing?.unitNetPrice * line.qtyOrdered, 0) || 0,
        authentication_state: isAuthenticated ? "Authenticated" : "Guest",
        branch_number: (session as any)?.defaultWarehouse?.name || "",
        branch_name: (session as any)?.defaultWarehouse?.description || "",
        sales_rep: (session as any).salesperson?.name || "",
        affiliation: currentBillTo?.companyName || "",
        items: lines.map((line: any, index: number) => ({
            item_id: line.productErpNumber || "",
            item_name: line.productName || "",
            coupon: "",
            affiliation: currentBillTo?.companyName || "",
            discount: line.pricing
                ? line.pricing.unitNetPrice < line.pricing.unitListPrice
                    ? line.pricing.unitListPrice - line.pricing.unitNetPrice
                    : 0
                : 0,
            index,
            item_brand: line.brand || "",
            ...formatCategories(line.category),
            item_list_id: pageType,
            item_list_name: list || "",
            item_variant: "",
            location_id: (session as any)?.pickUpWarehouse?.id || "",
            price: line.pricing?.unitNetPrice || 0,
            quantity: line.qtyOrdered,
        })),
    };
    dataLayer.push(googleAnalyticsData);
};

addToEndOfChain(addToWishList, _GaAddToWishList);
